import { loveLangNames } from '../data/questionData';

export const generatePDF = (questionPairs, selections, scores, maxScore, bestLangs, letterScores) => {
  let printResult = '';
  
  const pdfStyles = `
    <style>
      @page { 
        size: A4; 
        margin: 2cm; 
      }
      body { 
        font-family: Arial, sans-serif; 
        font-size: 12px; 
        line-height: 1.4; 
        color: #000;
        margin: 0;
        padding: 0;
      }
      h1, h2, h3 { 
        color: #000; 
        margin-top: 20px; 
        margin-bottom: 10px;
        page-break-after: avoid;
      }
      h1 { font-size: 18px; text-align: center; }
      h2 { font-size: 16px; }
      h3 { font-size: 14px; }
      .result-item { 
        border: 1px solid #000; 
        padding: 8px; 
        margin: 5px 0; 
        background: #f8f8f8;
        page-break-inside: avoid;
      }
      .question-item { 
        margin: 8px 0; 
        padding: 5px 0;
        border-bottom: 1px solid #ddd;
        page-break-inside: avoid;
      }
      .selected-answer {
        background: #e5e5e5;
        padding: 3px 6px;
        border: 1px solid #999;
        margin-left: 10px;
        display: inline-block;
      }
      .page-break { page-break-before: always; }
      .footer { 
        text-align: center; 
        font-size: 10px; 
        color: #666; 
        margin-top: 30px;
      }
    </style>
  `;
  
  printResult += `<h1>Szeretetnyelv Teszt – Eredmény</h1>`;
  
  if (maxScore > 0) {
    printResult += '<h2>Elsődleges szeretetnyelv:</h2>';
    bestLangs.forEach(idx => {
      printResult += `<div class="result-item"><strong>${loveLangNames[idx]}: ${scores[idx]} pont</strong></div>`;
    });
    
    printResult += '<h2>Összes szeretetnyelv pontszámai:</h2>';
    const sortedResults = loveLangNames
      .map((name, i) => ({ name, score: scores[i] }))
      .sort((a, b) => b.score - a.score);
    
    sortedResults.forEach(item => {
      printResult += `<div class="result-item">${item.name}: ${item.score} pont</div>`;
    });
  } else {
    printResult += '<div>Még nincs kitöltött válasz.</div>';
  }

  printResult += '<div class="page-break"></div>';
  printResult += '<h2>Válaszaid részletesen:</h2>';
  
  questionPairs.forEach((pair, idx) => {
    printResult += '<div class="question-item">';
    printResult += `<strong>${idx+1}. kérdés:</strong><br>`;
    
    const isASelected = selections[idx] === 0;
    printResult += `<strong>A)</strong> ${pair[0]}`;
    if (isASelected) {
      printResult += ' <span class="selected-answer">✓ VÁLASZTOTT</span>';
    }
    printResult += '<br>';
    
    const isBSelected = selections[idx] === 1;
    printResult += `<strong>B)</strong> ${pair[1]}`;
    if (isBSelected) {
      printResult += ' <span class="selected-answer">✓ VÁLASZTOTT</span>';
    }
    printResult += '<br>';
    
    if (selections[idx] === null) {
      printResult += '<em>Nincs válasz kijelölve.</em>';
    }
    
    printResult += '</div>';
  });

  printResult += '<div class="footer">Szeretetnyelv teszt – Gary Chapman alapján</div>';

  const win = window.open('', 'PRINT', 'height=900,width=700');
  win.document.write('<html><head><title>Szeretetnyelv Teszt eredménye</title>');
  win.document.write(pdfStyles);
  win.document.write('</head><body>');
  win.document.write(printResult);
  win.document.write('</body></html>');
  win.document.close();
  win.focus();
  win.print();
};